
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import BrandPaletteGenerator from "./BrandPaletteGenerator.vue";
import { singularityStore } from "@/store/store";
import {
  NamedColorPalette,
  SingularityBrandColor
} from "@/types/singularity/brand";
import IconButtonShuffle from "../../components/IconButtonShuffle.vue";
import Icon from "@/components/UI/Icon.vue";
import {
  shufflePalettes,
  shufflePrimaryPalette,
  addSecondaryPalette,
  saveBrandColorsAsGlobalColorsAndUpdateGlobalSettings
} from "@/lib/singularity/brand/color";

import TogglePanel from "../../components/TogglePanel.vue";

@Component({
  components: {
    BrandPaletteGenerator,
    IconButtonShuffle,
    Icon,
    TogglePanel
  }
})
export default class BrandManageColors extends Vue {
  get brand() {
    return singularityStore.brand;
  }

  updatePrimaryPalette(palette: NamedColorPalette) {
    singularityStore.setPalette({ type: "primary", palette });
  }

  updateSecondaryPalette(index: number, palette: NamedColorPalette) {
    singularityStore.updateSecondaryPalette({ index, palette });
  }

  removeSecondaryPalette(index: number) {
    singularityStore.removeSecondaryPalette(index);
  }

  shuffle() {
    shufflePalettes();
  }

  addPalette() {
    if (!this.brand.color.primary) {
      shufflePrimaryPalette();
    } else {
      addSecondaryPalette();
    }
  }

  @Watch("brand.color", { immediate: false, deep: true })
  onBrandColorsChange(newColors: SingularityBrandColor) {
    if (!newColors) {
      return;
    }
    saveBrandColorsAsGlobalColorsAndUpdateGlobalSettings(this.brand.color);
  }
}
